import { render, staticRenderFns } from "./JobDetailContent.vue?vue&type=template&id=42389b09&scoped=true&"
import script from "./JobDetailContent.vue?vue&type=script&lang=js&"
export * from "./JobDetailContent.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/job_details.css?vue&type=style&index=0&id=42389b09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42389b09",
  null
  
)

export default component.exports